import { PostTo } from '../types';

export const getVisibilityLabel = (input: PostTo, isAtPostLocation: boolean = false): string => {
  if (input.type === 'company') {
    return input.visibility === 'Private' ? 'Shareholders and board members' : 'Anyone';
  } else if (input.type === 'community') {
    switch (input.visibility) {
      case 'CommunityMembers':
        return `Everyone in ${input.profile.name}`;
      case 'Founders':
        return 'Founders';
      case 'CommunityMembersExceptFounders':
        return 'Investors, mentors & advisors';
    }
  }
  return '';
};
